module.exports = __webpack_public_path__ + "static/media/pause-circle-regular.7d6c4ab4.svg";